(() => {
  if (customElements.get('tsl-mobile-buy')) return;
  customElements.define('tsl-mobile-buy', class extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.source = this.form?.querySelector('button[name="add"]');
      this.price = document.getElementById(this.dataset.priceId);
      if (!this.source) return;
      this.proxy = this.querySelector('[data-buy-proxy]');
      this.status = this.querySelector('[data-buy-status]');
      this.mobile = matchMedia('(max-width: 749px)');
      this.sync = () => {
        const busy = this.source.classList.contains('loading') || this.source.classList.contains('is-loading') || this.source.getAttribute('aria-disabled') === 'true';
        this.proxy.disabled = this.source.disabled || busy;
        this.proxy.querySelector('span').textContent = busy ? 'Toevoegen…' : this.source.disabled ? this.source.innerText.trim() : 'In winkelwagen';
        const amount = this.price?.querySelector('ins .amount') || this.price?.querySelector('.price > .amount') || this.price?.querySelector('.amount');
        if (amount) this.querySelector('[data-buy-price]').textContent = amount.textContent;
      };
      this.update = () => {
        const rect = this.source.getBoundingClientRect();
        const passed = rect.bottom < 0;
        document.body.classList.toggle('tsl-main-buy-visible', this.mobile.matches && rect.top < innerHeight && rect.bottom > 0);
        this.hidden = !this.mobile.matches || !passed;
        document.body.classList.toggle('tsl-mobile-buy-visible', !this.hidden);
      };
      this.onClick = () => {
        this.sync();
        if (this.proxy.disabled) return;
        this.status.textContent = '';
        this.source.click();
        this.sync();
      };
      this.proxy.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(() => {
        this.sync();
        const err = this.form.closest('product-form')?.querySelector('.product-form__error-message');
        if (err?.textContent.trim()) this.status.textContent = err.textContent;
      });
      this.observer.observe(this.source, {attributes:true,childList:true,subtree:true});
      if (this.price) this.observer.observe(this.price, {childList:true,subtree:true});
      const error = this.form.closest('product-form')?.querySelector('.product-form__error-message');
      if (error) this.observer.observe(error, {childList:true,subtree:true});
      this.intersection = new IntersectionObserver(this.update);
      this.intersection.observe(this.source);
      this.mobile.addEventListener('change', this.update);
      this.sync(); this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect(); this.intersection?.disconnect();
      this.mobile?.removeEventListener('change', this.update);
      this.proxy?.removeEventListener('click', this.onClick);
      document.body.classList.remove('tsl-mobile-buy-visible', 'tsl-main-buy-visible');
    }
  });
})();
